/**
 * Stimulus mixin: close when clicking outside element.
 * Call add() when opening, remove() when closing.
 */

/**
 * @param {Element} element - element to check containment
 * @param {() => void} onOutside - callback when click is outside
 * @returns {{ add: () => void, remove: () => void }}
 */
export function useClickOutside(element, onOutside) {
  const handler = (event) => {
    if (!element.contains(event.target)) onOutside()
  }
  return {
    add() {
      document.addEventListener("click", handler)
    },
    remove() {
      document.removeEventListener("click", handler)
    }
  }
}
